import RegisterError from "../common/register-error";

export default function Input({
  className = "",
  type,
  label,
  value,
  onChange,
  errorCode,
  id = undefined,
  autoComplete = undefined,
}) {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label htmlFor={id} className="font-normal">
          {label}
        </label>
      )}
      <input
        id={id}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e)}
        type={type}
        value={value ?? ""}
        className={`rounded-md p-2.5 max-w-[350px] border ${
          errorCode
            ? "border-[#ff4900]"
            : "border-altgray-200 focus:border-[#bee0fd]"
        }`}
      />
      {errorCode && <RegisterError errorCode={errorCode} />}
    </div>
  );
}
